<pbc-filter [config]="OffeneGutachtenFilterConfig" [filter]="offeneGutachten.filter$ | async" (filterChange)="offeneGutachten.filter$.next($event)"></pbc-filter>
